import { DateTime } from 'luxon';
import { ActType } from 'shell/constants/act-type';
import { DatiAggiuntiviSide, ModelEventoDTO } from 'shell/models/act-category-list';
import { ActManagementForm } from 'shell/view-models/act-form';

export const transformBirthdayDocument = (
  modelEventoDTO: ModelEventoDTO,
  datiAggiuntiviSide: DatiAggiuntiviSide
): ActManagementForm => {
  return {
    actType: ActType.AttoDigitale,
    digital: {
      documentDate: modelEventoDTO.dataformazione
        ? DateTime.fromISO(modelEventoDTO.dataformazione)
        : null,
      istatCode: datiAggiuntiviSide.idComuneRegistrazione || '',
      municipality: datiAggiuntiviSide.idComuneRegistrazione
        ? {
            id: datiAggiuntiviSide.idComuneRegistrazione || '',
            description: datiAggiuntiviSide.nomeComuneRegistrazione || '',
            idProvince: datiAggiuntiviSide.idProvinciaRegistrazione
              ? Number.parseInt(datiAggiuntiviSide.idProvinciaRegistrazione, 10)
              : undefined,
            province: datiAggiuntiviSide.siglaProvinciaRegistrazione || '',
          }
        : undefined,
      idAnsc: modelEventoDTO.idAnsc,
      year: modelEventoDTO.idAnsc ? modelEventoDTO.idAnsc.split('-')[0] : '',
      nationalNumber: modelEventoDTO.idAnsc ? modelEventoDTO.idAnsc.split('-')[1] : '',
      numberMunicipality: modelEventoDTO.idAnsc ? modelEventoDTO.idAnsc.split('-')[2] : '',
    },
  };
};
